module.exports = __webpack_public_path__ + "05_mid_yellow.55e49043.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_mid_yellow.png
// module id = ULUR
// module chunks = 0